import Iconify from '@components/iconify';
import { Stack, useTheme } from '@mui/material';
import icons from 'src/utils/icons';

interface Props {
  small?: boolean;
  white?: boolean;
  color?: string;
}

export default function Loader({ small = false, white = false, color }: Props) {
  const theme = useTheme();
  return (
    <Stack direction="row" alignContent="center" justifyContent="center">
      <Iconify
        sx={{ height: small ? 20 : 30, width: small ? 20 : 30 }}
        icon={icons.commons.loading}
        color={white ? theme.palette.common.white : (color ?? theme.palette.secondary.main)}
      />
    </Stack>
  );
}
